<template>
    <div>
        <specialtie-modal ref="specialtiesform" id="specialties-form" :title="titleForm" :isLoading="isLoadingGrid"
            :specialties="specialties" :specialtie="specialtie" @on-create="handleCreate" @on-update="handleUpdate" />
        <bita-breadcrumb :items="breadCrumbs" />


        <div class="wrapper wrapper-content animated fadeInRight">
            <bita-ibox :is-loading="isLoadingGrid">
                <div slot="body">
                    <bita-bootbutton type="primary" title="تخصص جدید" icon="fas fa-plus-square" btn-width="200px"
                        @click.native="createSpecialtie" />
                    <hr />
                 
                    <bita-grid 
                        ref="grid" 
                        :columns="gridColumns" 
                        :read-data="readData" 
                        :grid-server-side="true"
                        :schema-total="'total'"
                        :schema-data="'data'"
                        :batch="true"
                        :page-size="pageSize"
                        :server-paging="true"
                        :current-page="currentPage" 
                        :has-row-number="true" />
                </div>
            </bita-ibox>
        </div>
    </div>
</template>
<script>

import specialtiesApi from '../../../api/clinic/specialtiesApi';
import SpecialtieModal from './components/SpecialtieModal.vue';

export default {
    components: { SpecialtieModal },
    data() {
        return {
            pageSize: 10,
            titleForm: "",
            currentPage: 1,
            breadCrumbs: [
                { title: "صفحه اصلی", link: "/" },
                {
                    title: "تخصصص ها",
                    link: "/clinic/specialties",
                    active: true,
                },
            ],
            specialties: [],
            specialtie: {},
            isLoadingGrid: false,
        };
    },

    mounted() {
    },

    computed: {
        gridColumns() {
            return [
                {
                    field: "avatar",
                    title: "عکس",
                    template: this.getImage,
                    width: "100px",
                },
                {
                    field: "name",
                    title: "عنوان ",
                    template: ({ name }) => (name ? name : " - "),
                },
                {
                    title: "عملیات",
                    command: this.gridCommands(),
                },
            ];
        },
    },
    methods: {
        getFormData(data) {
            let formData = new FormData();
            for (var key in data) {
                if (data[key] != null) formData.append(key, data[key]);
            }
            return formData;
        },
        getImage(element) {
            return `
      <img width="80" src="${element.avatar}" alt="تصویر"
       class="img rounded-circle circle-border slider-image">
      `;
        },
        toggleModal() {
            this.$toggleModal("#specialties-form");
        },
        handleUpdate(data) {
            let formData = this.getFormData(data);
            specialtiesApi.update(data.id, formData)
                .then(res => {
                    this.loadData();
                }).finally(() => {
                    this.toggleModal();

                })
        },
        handleCreate(data) {
            let formData = this.getFormData(data);
            specialtiesApi.create(formData)
                .then(res => {
                    this.loadData();
                }).finally(() => {
                    this.toggleModal();
                    this.loadData();
                })
        },
        createSpecialtie() {
            this.$refs.specialtiesform.reset();
            this.titleForm = "ایجاد تخصص";
            this.toggleModal();
        },
        readData(e) {
            this.$resetGrid();
            this.pageSize = e.data.pageSize;
            this.currentPage = e.data.page;
            this.isLoadingGrid = true;
            specialtiesApi
                .get({
                    page_size: this.pageSize,
                    page: this.currentPage,
                })
                .then(({ data }) => {
                    this.specialties = data.data;
                    e.success(data);
                })
                .catch(() => {
                    e.success([]);
                })
                .finally(() => {
                    this.isLoadingGrid = false;
                });

        },
        loadData() {
            this.$refs.grid.loadDataSource();
        },

        delete(e) {
            let data = this.$refs.grid.getSelectedGridRow(e);

            this.$alert("question", `آیا از حذف ${data.name} اطمینان دارید؟`, "", {
                confirmButtonText: "بله",
            }).then((result) => {
                if (result.value) {
                    this.isLoadingGrid = true;
                    specialtiesApi
                        .delete(data.id)
                        .then((res) => {
                            this.$izitoast("success", "عملیات موفق", res.data);
                            this.loadData();
                        })
                        .finally(() => {
                            this.isLoadingGrid = false;
                            this.loadData();
                        });
                }
            });
        },
        loadData() {
            this.$refs.grid.loadDataSource();
        },
        gridCommands() {
            let commands = [];

            commands.push({
                text: "edit",
                click: this.edit,
                template: this.gridButtons.edit,
            });
            commands.push({
                text: "delete",
                click: this.delete,
                template: this.gridButtons.delete,
            });
            return commands;
        },

        edit(e) {
            this.specialtie = this.$refs.grid.getSelectedGridRow(e);
            this.$refs.specialtiesform.setFormData(this.specialtie);
            this.titleForm = "آپدیت تخصص";
            this.toggleModal();
        },
    },
};
</script>
<style scoped>
.fade-enter {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 1s ease-in;
}

.fade-leave {
    opacity: 0.2;
}

.badge {
    margin: 2px;
    font-size: 13px !important;
    font-weight: 800;
}
</style>
